import { render, staticRenderFns } from "./burger-menu.vue?vue&type=template&id=e0570352&scoped=true"
import script from "./burger-menu.vue?vue&type=script&lang=js"
export * from "./burger-menu.vue?vue&type=script&lang=js"
import style0 from "./burger-menu.vue?vue&type=style&index=0&id=e0570352&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0570352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0570352')) {
      api.createRecord('e0570352', component.options)
    } else {
      api.reload('e0570352', component.options)
    }
    module.hot.accept("./burger-menu.vue?vue&type=template&id=e0570352&scoped=true", function () {
      api.rerender('e0570352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/burger-menu.vue"
export default component.exports